import PatientWeightInput from './PatientWeightInput';

export default PatientWeightInput;
